import CustomImage from '@/components/CustomImage';
import { useFormatText } from '@/hooks/useFormatText';
import { useSettingsStore } from '@/store/useSettingsStore';

const MaintenancePage = () => {
  const { formatText } = useFormatText();
  const direction = useSettingsStore((s) => s.settings.direction);

  return (
    <div
      dir="ltr"
      className="relative min-h-screen w-full bg-brand-default overflow-hidden"
    >
      {/* Wave background — desktop only */}
      <CustomImage
        src="/assets/images/maintenance-bg.png"
        alt=""
        aria-hidden="true"
        className="hidden lg:block absolute inset-0 w-full h-full object-fill pointer-events-none select-none"
      />

      {/* Content */}
      <div className="relative z-10 flex flex-col lg:flex-row min-h-screen max-lg:justify-center max-lg:items-center">
        {/* ── Text panel ── */}
        <div
          className="flex flex-col justify-center gap-4
                     px-6 sm:px-10 md:px-14 lg:px-14 xl:px-20
                     pt-12 pb-6 lg:py-0
                     w-full lg:w-[42%] xl:w-[45%] shrink-0"
          dir={direction}
        >
          <h1 className="text-white font-bold uppercase leading-[1.2] xl:text-[64px] md:text-5xl max-md:text-4xl">
            {formatText('maintenance.title-line1')}
            <br />
            {formatText('maintenance.title-line2')}
          </h1>
          <p className="text-white font-normal leading-relaxed text-[22px] max-w-166 tracking-[-0.28px]">
            {formatText('maintenance.description')}
          </p>
        </div>

        {/* ── Illustration ── */}
        <div className="flex lg:flex-1 items-center justify-center px-6 sm:px-10 pb-10 pt-4 lg:py-0">
          <CustomImage
            src="/assets/images/maintenance.png"
            alt={formatText('maintenance.alt')}
            className="w-full h-auto object-contain
                       sm:max-w-[320px]
                       md:max-w-110
                       lg:max-w-140
                       xl:max-w-227.5"
          />
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
